import { Box, Modal } from "@mui/material";
import PropTypes from "prop-types";

const CancelModal = ({
  cancelOpen,
  handleCancelClose,
  handleLeave,
  modalTitle,
  modalDescription,
}) => {
  return (
    <Modal
      open={cancelOpen}
      onClose={handleCancelClose}
      aria-labelledby="cancel-notif-modal"
      aria-describedby="cancel-notif-description"
      className="modal-cancel-notif"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          boxShadow: 24,
          backgroundColor: "#d0d0d0",
          border: "5px solid #000",
          p: 3,
          color: "#000000",
        }}
      >
        <div className="custom-modal-content">
          <h5>{modalTitle}</h5>
          <p>{modalDescription}</p>
        </div>
        <div className="modal-footer-btns">
          <div className="filter-btns-group">
            <button type="button" onClick={handleCancelClose}>
              Go Back
            </button>
            <button type="button" onClick={handleLeave}>
              Leave
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

// PropTypes validation
CancelModal.propTypes = {
  cancelOpen: PropTypes.any,
  handleCancelClose: PropTypes.any,
  closeContactDrawer: PropTypes.any,
  modalTitle: PropTypes.any.isRequired,
  modalDescription: PropTypes.any.isRequired,
};

export default CancelModal;
